const TONES = { default: "", secondary: "", outline: "", accent: "badge-accent", success: "badge-success", warning: "badge-warning", danger: "badge-danger", destructive: "badge-danger", info: "badge-info" };

export function Badge({ children, className = "", variant = "default", ...props }) {
  return (
    <span className={`badge ${TONES[variant] ?? ""} ${className}`} {...props}>
      {children}
    </span>
  );
}
